var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckicon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000005995"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 69",
    d: "M4.17969 12.02L7.97969 15.82C8.99302 12.78 12.6157 5.56 18.9997 1",
    stroke: "#40C900",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 814"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_5159_1354",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3306 6.26103C18.6087 8.12167 19.1824 10.3766 18.9491 12.6219C18.7158 14.8671 17.6906 16.9559 16.0572 18.514C14.4239 20.072 12.2891 20.9976 10.0353 21.1248C7.7816 21.252 5.55622 20.5725 3.7579 19.2081C1.95959 17.8437 0.705877 15.8836 0.221391 13.6789C-0.263095 11.4741 0.0533088 9.16896 1.11391 7.17631C2.17452 5.18367 3.91001 3.6338 6.00943 2.8044C8.10886 1.975 10.435 1.92026 12.5711 2.65L11.8774 4.68077C10.2238 4.11588 8.42311 4.15825 6.79794 4.80029C5.17276 5.44234 3.82931 6.6421 3.00829 8.18461C2.18727 9.72713 1.94234 11.5116 2.31738 13.2183C2.69243 14.925 3.66293 16.4423 5.05501 17.4985C6.4471 18.5547 8.16978 19.0807 9.91441 18.9822C11.659 18.8837 13.3116 18.1673 14.576 16.9611C15.8404 15.755 16.634 14.1381 16.8146 12.4C16.9952 10.662 16.5511 8.91642 15.5617 7.47609L17.3306 6.26103Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.3306 6.26103C18.6087 8.12167 19.1824 10.3766 18.9491 12.6219C18.7158 14.8671 17.6906 16.9559 16.0572 18.514C14.4239 20.072 12.2891 20.9976 10.0353 21.1248C7.7816 21.252 5.55622 20.5725 3.7579 19.2081C1.95959 17.8437 0.705877 15.8836 0.221391 13.6789C-0.263095 11.4741 0.0533088 9.16896 1.11391 7.17631C2.17452 5.18367 3.91001 3.6338 6.00943 2.8044C8.10886 1.975 10.435 1.92026 12.5711 2.65L11.8774 4.68077C10.2238 4.11588 8.42311 4.15825 6.79794 4.80029C5.17276 5.44234 3.82931 6.6421 3.00829 8.18461C2.18727 9.72713 1.94234 11.5116 2.31738 13.2183C2.69243 14.925 3.66293 16.4423 5.05501 17.4985C6.4471 18.5547 8.16978 19.0807 9.91441 18.9822C11.659 18.8837 13.3116 18.1673 14.576 16.9611C15.8404 15.755 16.634 14.1381 16.8146 12.4C16.9952 10.662 16.5511 8.91642 15.5617 7.47609L17.3306 6.26103Z",
    stroke: "#03257C",
    strokeWidth: 4,
    mask: "url(#path-2-inside-1_5159_1354)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckicon1);
export default __webpack_public_path__ + "static/media/checkicon1.170035763ea8f1293ebdf39188198b1c.svg";
export { ForwardRef as ReactComponent };